import React from "react";

function CloseIcon() {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.586914" width="24" height="24" rx="12" fill="#E5E5E5" />
      <path
        d="M12.5869 10.8891L16.476 7L17.5869 8.11094L13.6979 12L17.5869 15.8891L16.476 17L12.5869 13.1109L8.69785 17L7.58691 15.8891L11.476 12L7.58691 8.11094L8.69785 7L12.5869 10.8891Z"
        fill="#4F4F4F"
      />
    </svg>
  );
}

export default CloseIcon;
